import React from 'react';
import { Text, UnorderedList, ListItem, OrderedList, Box } from '@chakra-ui/react';
import { Figure } from '../Figure';
import { Chart } from '../Chart';
import { StatBlock } from '../StatBlock';
import { LendingMap } from '../LendingMap';
import { CalloutBox } from '../CalloutBox';
import { InlineImage } from '../InlineImage';
import { SectionLink } from '../SectionLink';

const getTextStyle = (node, styleDefault) => {
  const specialStyleMark = node.markDefs.find((mark) => mark._type === 'textStyle');
  return specialStyleMark?.style || styleDefault;
};

export const components = {
  types: {
    figure: ({ value }) => <Figure data={value} />,
    statBlock: ({ value }) => <StatBlock data={value} />,
    lendingMap: ({ value }) => <LendingMap data={value} />,
    calloutBox: ({ value }) => <CalloutBox data={value} />,
    inlineImage: ({ value }) => <InlineImage data={value} />,
    sectionLink: ({ value }) => <SectionLink data={value} />,
  },
  marks: {
    link: ({ value, children }) => {
      const target = (value?.href || '').startsWith('http') ? '_blank' : undefined;
      return (
        <a href={value?.href} target={target}>
          {children}
        </a>
      );
    },
  },
  list: {
    bullet: ({ children }) => (
      <UnorderedList spacing={10} listStylePosition='outside' my={10}>
        {children}
      </UnorderedList>
    ),
    number: ({ children }) => (
      <OrderedList spacing={10} listStylePosition='inside' marginLeft='0' my={10}>
        {children}
      </OrderedList>
    ),
  },
  listItem: {
    bullet: ({ children }) => <ListItem textStyle='body'>{children}</ListItem>,
    number: ({ children }) => <ListItem textStyle='body'>{children}</ListItem>,
  },
  block: {
    normal: ({ children, node }) => {
      if (node?._type === 'chart') {
        return <Chart data={node} />;
      }
      return <Text textStyle={getTextStyle(node, 'body')}>{children}</Text>;
    },

    h1: ({ children, node }) => (
      <Text as='h1' textStyle={getTextStyle(node, 'h1')}>
        {children}
      </Text>
    ),
    h2: ({ children, node }) => (
      <Text as='h2' textStyle={getTextStyle(node, 'h2')}>
        {children}
      </Text>
    ),
    h3: ({ children, node }) => (
      <Text as='h3' textStyle={getTextStyle(node, 'h3')}>
        {children}
      </Text>
    ),
    h4: ({ children, node }) => (
      <Text as='h4' textStyle={getTextStyle(node, 'h4')}>
        {children}
      </Text>
    ),
    h5: ({ children, node }) => (
      <Text as='h5' textStyle={getTextStyle(node, 'h5')}>
        {children}
      </Text>
    ),
    h6: ({ children, node }) => (
      <Text as='h6' textStyle={getTextStyle(node, 'h6')}>
        {children}
      </Text>
    ),
    footnote: ({ children }) => (
      <Box borderTop='1px solid lightGrey' pt={20}>
        <Text as='p' fontSize='sm' fontWeight={300}>
          {children}
        </Text>
      </Box>
    ),
  },
};
